// @flow

import * as React from "react";
import { Status } from "buba-components";
import {
  formatCurrency,
  formatDateFromISO,
  timeDistanceFromISO
} from "buba-components/src/utils/formatters";
import { format } from "date-fns";
import { datePickerDisplayFormat, timeFormat } from "buba-components/src/utils/formats";
import styles from "./InquiryList.scss";
import type { BankOfferStatus } from "../../data/types/bankOffers";

const getBankTime = (timeInformation: string, tab: BankOfferStatus) => {
  if (!timeInformation) {
    return "";
  }

  switch (tab) {
    case "new":
      return timeDistanceFromISO(timeInformation);
    case "in_progress":
      return timeDistanceFromISO(timeInformation);
    case "offer_submitted":
      return formatDateFromISO(timeInformation);
    case "closed":
      return formatDateFromISO(timeInformation);
    default:
      return "";
  }
};

const getsharedTableData = inquiry => {
  return {
    id: inquiry.id,
    created_at: (
      <>
        <div>{format(inquiry.date, datePickerDisplayFormat)}</div>
        <div>{`${format(inquiry.date, timeFormat)} Uhr`}</div>
      </>
    ),
    company: <div className={styles.bold}>{inquiry.company}</div>,
    amount: (
      <div className={styles.bold}>
        {inquiry.amount == null ? "-" : formatCurrency(inquiry.amount)}
      </div>
    )
  };
};

// eslint-disable-next-line import/prefer-default-export
export const getTableDataForCustomer = (inquiries, tabId) =>
  inquiries.map(inquiry => ({
    ...getsharedTableData(inquiry),
    bankTime: getBankTime(inquiry.bankTime, tabId),
    collaterals: inquiry.collaterals,
    status: <Status site="customer" status={inquiry.status} />
  }));

// eslint-disable-next-line import/prefer-default-export
export const getTableDataForBankAdvisor = inquiries =>
  inquiries.map(inquiry => ({
    ...getsharedTableData(inquiry),
    status: <Status site="ba_inquiry" status={inquiry.status} />
  }));
